import { FC } from 'react';
import classnames from 'classnames';
import { graphql, useFragment } from 'react-relay';

// components
import { Link } from 'dibs-elements/exports/Link';

// styles
import dibsCss from 'dibs-css';
import styles from './PdpSharedDetailCancelationPolicy.scss';

// types
import { PdpSharedDetailCancelationPolicy_item$key as Item } from './__generated__/PdpSharedDetailCancelationPolicy_item.graphql';

const itemFragment = graphql`
    fragment PdpSharedDetailCancelationPolicy_item on Item {
        cancelationPolicy {
            header
            body
            linkData {
                text
                path
            }
        }
    }
`;

export const PdpSharedDetailCancelationPolicy: FC<{ item: Item }> = ({ item: itemRef }) => {
    const item = useFragment(itemFragment, itemRef);
    const { body, header, linkData } = item?.cancelationPolicy || {};
    const { path, text } = linkData || {};

    if (!body || !header) {
        return null;
    }

    return (
        <div className={dibsCss.mtSmall}>
            <div className={classnames(dibsCss.sassyFontBodyMediumHeavy, styles.header)}>
                {header}
            </div>
            <div className={dibsCss.sassyFontBodyMedium}>
                {body}
                {path && text && (
                    <>
                        {' '}
                        <Link target="_blank" href={path}>
                            {text}
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};
